import { Routes, Route, Navigate } from "react-router-dom";
import { DashboardShell } from "@/components/dashboard/DashboardShell";
import { haafCoordinatorConfig } from "@/config/haaf-coordinator";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Overview from "./overview";
import HafPayments from "./haf-payments";
import Settings from "./settings";

export default function HaafCoordinatorDashboard() {
  return (
    <ProtectedRoute allowedRoles={["haaf-coordinator"]}>
      <DashboardShell navItems={haafCoordinatorConfig.sidebarNav}>
        <Routes>
          <Route path="overview" element={<Overview />} />
          <Route path="haf-payments/*" element={<HafPayments />} />
          <Route path="settings" element={<Settings />} />
          <Route path="*" element={<Navigate to="overview" replace />} />
        </Routes>
      </DashboardShell>
    </ProtectedRoute>
  );
}
